import { useState, useEffect } from 'react';
import { listenToCollection } from '../services/firestore.service';
import { where } from 'firebase/firestore';

export const useInvestments = (userId) => {
  const [investments, setInvestments] = useState([]);
  const [totalTrees, setTotalTrees] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const unsubscribe = listenToCollection(
      'investments',
      [where('userId', '==', userId)],
      (data) => {
        setInvestments(data);
        // Calculate aggregates
        const trees = data.reduce((acc, curr) => acc + (curr.treeCount || 0), 0);
        const value = data.reduce((acc, curr) => acc + (curr.currentValue || 0), 0);
        setTotalTrees(trees);
        setTotalValue(value);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [userId]);

  return { investments, totalTrees, totalValue, loading, error };
};

